import { useEffect, useRef } from "react";
import ZoomServices from "../../../services/ZoomServices";

export default function ZoomCallback() {
  const hasExchanged = useRef(false);

  useEffect(() => {
    if (hasExchanged.current) return;

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    if (!code) return;

    hasExchanged.current = true;

    const stateParam = params.get("state");
    const openerOrigin = stateParam ? decodeURIComponent(stateParam) : window.location.origin;

    ZoomServices.exchangeCode(code)
      .then(() => {
        window.opener.postMessage(
          { type: "ZOOM_OAUTH_SUCCESS" },
          openerOrigin
        );
        window.close();
      })
      .catch(err => {
        console.error(err);

        window.opener.postMessage(
          { type: "ZOOM_OAUTH_FAILED" },
          openerOrigin
        );

        window.close();
      });
  }, []);

  return <p>Connecting to Zoom…</p>;
}
